import { render, staticRenderFns } from "./UserPopup.vue?vue&type=template&id=10f9e4e1&"
import script from "./UserPopup.vue?vue&type=script&lang=js&"
export * from "./UserPopup.vue?vue&type=script&lang=js&"
import style0 from "./UserPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports